import { NavigateFunction } from 'react-router-dom';

function updateUrlInView(
  navigate: NavigateFunction,
  inView: boolean,
  idName: string,
) {
  if (inView) {
    navigate(`#${idName}`, { replace: true });
  }
}

export default updateUrlInView;
